// @ts-nocheck
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFlyoutDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetFlyoutDrawerIsOpen";
import setInitialValues from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetInitialValues";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import setSignInOverlayIsOpen from "@insite/client-framework/Store/Components/SignInOverlay/Handlers/SetSignInOverlayIsOpen";
import {
    getCurrencies,
    getFulfillmentLabel,
    getIsPunchOutSession,
    getLanguages,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import setCurrency from "@insite/client-framework/Store/Context/Handlers/SetCurrency";
import setLanguage from "@insite/client-framework/Store/Context/Handlers/SetLanguage";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import removeCart from "@insite/client-framework/Store/Data/Carts/Handlers/RemoveCart";
import { getHeader, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
import { getPageLinkByPageType, LinkModel, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import ShowInventoryToggle, { ShowInventoryToggleStyles } from "@insite/content-library/Components/ShowInventoryToggle";
import ShowPricingToggle, { ShowPricingToggleStyles } from "@insite/content-library/Components/ShowPricingToggle";
// import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button"; // Sas
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Globe from "@insite/mobius/Icons/Globe";
import MapPin from "@insite/mobius/Icons/MapPin";
// import Menu from "@insite/mobius/Icons/Menu"; // Starter Custom Code
// import User from "@insite/mobius/Icons/User"; // Starter Custom Code
// import { MappedLink } from "@insite/mobius/Menu"; // Sas
// import PanelMenu, { PanelMenuPresentationProps } from "@insite/mobius/PanelMenu"; // Starter Custom Code
import PanelRow, { PanelRowPresentationProps } from "@insite/mobius/PanelMenu/PanelRow";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import omitSingle from "@insite/mobius/utilities/omitSingle";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css, ThemeProps, withTheme } from "styled-components";

/* Store Custom Code */
import { Dictionary } from "@insite/client-framework/Common/Types";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { IconWrapper } from "@insite/mobius/Icon";
import CubeFill from "@store/Library/Components/Toolkit/Icons/Cube/CubeFill";
import Menu from "@store/Library/Components/Toolkit/Icons/Menu";
import PersonFill from "@store/Library/Components/Toolkit/Icons/Person/PersonFill";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import PanelMenu, { PanelMenuPresentationProps } from "@store/MobiusOverrides/PanelMenu/PanelMenu";
import useIsDuplicate from "@toolkit/Framework/Common/Hooks/useIsDuplicate";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { LinkModelWithIcon } from "@toolkit/Framework/Store/Links/LinksSelectors";
import { iconColorStyles, iconOffsetStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";
// import { menuPanelRowStyles, menuPanelContentRowStyles } from "@store/Themes/common/mixins/menu"; // Sas
import { headerLinkListIcons } from "@store/Overrides/Widgets/Header/HeaderLinkList";
import { formGridProps } from "@store/Themes/common/props/form";
import { headerIconButtonProps } from "@store/Themes/common/props/header";
import { menuPanelProps } from "@store/Themes/common/props/menu";

// Foundation --->
import { useDisplayName } from "@store/Framework/Store/Foundation/Context/ContextHooks";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Person from "@store/Library/Components/Icons/Person/PersonFill";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";

// Sas --->
import Button, { ButtonIcon, ButtonPresentationProps, ButtonVariants } from "@store/MobiusOverrides/Button/Button";
import { MappedLink } from "@store/Overrides/Widgets/Header/MainNavigation";
import { contentSpacingStyles, menuPanelContentRowStyles, menuPanelRowStyles } from "@store/Themes/common/mixins";
// <--- Sas

const LanguageMenu = getWidgetComponent("Common/LanguageMenu");

export interface CustomLinkModel extends LinkModel {
    openInNewWindow?: boolean;
    overriddenTitle?: boolean;
}
// <--- Foundation

export interface NavigationDrawerIconPreset {
    size?: string;
    offset?: string;
    spacing?: string;
}

export const navigationDrawerIconPresets: Dictionary<NavigationDrawerIconPreset> = {
    default: {
        size: pxToRem(22),
        offset: pxToRem(2),
        spacing: pxToRem(8),
    },
    large: {
        size: pxToRem(32),
        offset: pxToRem(4),
        spacing: pxToRem(14),
    },
};

export type NavigationDrawerIconPresetType = keyof typeof navigationDrawerIconPresets;
const iconDefault = navigationDrawerIconPresets["default"];
const iconLarge = navigationDrawerIconPresets["large"];
const languageIconSize = pxToRem(18);

const getIconProps = (
    src?: IconProps["src"],
    size?: string | null,
    preset: NavigationDrawerIconPresetType = "default",
): IconProps => {
    const _preset = navigationDrawerIconPresets[preset];
    const _size = size || _preset.size;

    return {
        src,
        css: css`
            ${iconScalableStyles(_size, false)}
            ${iconOffsetStyles(_preset.offset, _preset.spacing)}
            ${_size !== _preset.size ? `width: ${_preset.size};` : null}
            justify-content: center;
        `,
    };
};

const panelSectionWrapperStyles = () => css`
    display: flex;
    align-items: center;
`;
/* Store Custom Code */

const mapStateToProps = (state: ApplicationState) => {
    /* Store Custom Code */
    const { isAuthenticated, isGuest, firstName, lastName, userName } = getSession(state);
    const targetZone = ["Left", "Right"];

    // Foundation --->
    const headerLinkListLinkFields =
        (getWidgetsByPageId(state, getHeader(state).id).find((widget: WidgetProps) => {
            return widget.type === "Header/HeaderLinkList";
        })?.fields.links as CustomLinkModel[]) ?? [];
    // <--- Foundation
    const displayPricingAndInventory = state.context.session?.displayPricingAndInventory || false;
    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";

    return {
        currencies: getCurrencies(state),
        currentCurrencyId: state.context.session.currency?.id,
        currentCurrencySymbol: state.context.session.currency?.currencySymbol,
        languages: getLanguages(state),
        currentLanguage: state.context.session.language,
        currentLocation: getLocation(state),
        userName: state.context.session?.userName,
        isGuest: state.context.session?.isGuest,
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        signInUrl: getPageLinkByPageType(state, "SignInPage"),
        vmiDashboardPageUrl: getPageLinkByPageType(state, "VmiDashboardPage")?.url,
        homePageUrl: getPageLinkByPageType(state, "HomePage")?.url,
        headerLinkListLinkFields,
        showCustomerMenuItem: getSettingsCollection(state).accountSettings.enableWarehousePickup,
        fulfillmentLabel: getFulfillmentLabel(state),
        navDrawerIsOpen: state.components.addressDrawer.navDrawerIsOpen,
        flyoutDrawerIsOpen: state.components.addressDrawer.flyoutDrawerIsOpen,
        isPunchOutSession: getIsPunchOutSession(state),
        cart: getCurrentCartState(state).value,
        visibilityState: findVisibilityState(state.data.pages.widgetsById),
        displayPricingAndInventoryToggles: displayPricingAndInventory && currentMode === "Storefront",
        // Store Custom Code
        fulfillmentMethod: state.components.addressDrawer.fulfillmentMethod,
        showAddressesSelector: isAuthenticated && !isGuest,
        userDisplayName: firstName ? `${firstName}${lastName ? ` ${lastName}` : ""}` : userName,
        // Foundation
        isSigningIn: state.context.isSigningIn,
    };
};

const mapDispatchToProps = {
    setCurrency,
    setLanguage,
    signOut,
    cancelPunchOut,
    setInitialValues,
    setNavDrawerIsOpen,
    setFlyoutDrawerIsOpen,
    removeCart,
    setSignInOverlayIsOpen,
};

interface OwnProps {
    links: MappedLink[];
    showQuickOrder: boolean;
    quickOrderLink: PageLinkModel | undefined;
    displayVmiNavigation?: boolean;
    vmiPageLinks?: (PageLinkModel | undefined)[];
    displayModeSwitch?: boolean;
    currentMode?: string;
    isCompactHeaderFlyout?: boolean;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    // Store Custom Code
    uniqueId?: string;
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory &
    ThemeProps<BaseTheme>;

export interface NavigationDrawerStyles {
    menuTriggerButton?: ButtonPresentationProps;
    drawer?: DrawerPresentationProps;
    drawerSectionWrapper?: InjectableCss;
    panelMenu?: PanelMenuPresentationProps;
    panelSectionWrapper?: InjectableCss;
    menuRowIcon?: IconProps;
    userRowTypography?: TypographyPresentationProps;
    punchOutUserRowText?: TypographyPresentationProps;
    mainNavigationRow?: PanelRowPresentationProps;
    mainNavigationRowIcon?: IconProps;
    punchOutNavigationRowIcon?: IconProps;
    mainNavigationRowTypography?: TypographyPresentationProps;
    logoLinks?: PanelRowPresentationProps & { typographyProps?: TypographyPresentationProps }; // Store Custom Code
    currencySymbol?: TypographyPresentationProps;
    changeCustomerRow?: PanelRowPresentationProps;
    changeCustomerRowContainer?: GridContainerProps;
    fulfillmentMethodGridItem?: GridItemProps;
    addressesGridItem?: GridItemProps;
    pickUpAddressGridItem?: GridItemProps;
    applyButtonGridItem?: GridItemProps;
    showInventoryToggle?: ShowInventoryToggleStyles;
    showPricingToggle?: ShowPricingToggleStyles;
    signOutRow?: PanelRowPresentationProps;
    signOutRowText?: TypographyPresentationProps;
    // Store Custom Code
    drawerSecondarySectionWrapper?: InjectableCss;
    largePanelSectionWrapper?: InjectableCss;
    largeRow?: PanelRowPresentationProps;
    largeRowWrapper?: InjectableCss;
    largeRowTitle?: TypographyPresentationProps;
    largeRowText?: TypographyPresentationProps;
    accountIcon?: IconProps;
    fulfillmentIcon?: IconProps;
    languageIcon?: IconProps;
    fulfillmentRow?: PanelRowPresentationProps;
    fulfillmentRowText?: TypographyPresentationProps;
    // Foundation
    menuIcon?: IconProps;
    languageMenu?: LinkPresentationProps;
    // Sas
    buttonsWrapper?: InjectableCss;
    buttons?: ButtonPresentationProps;
}

const StyledSection = getStyledWrapper("section");
const StyledSpan = getStyledWrapper("span");

export const navigationDrawerStyles: NavigationDrawerStyles = {
    menuTriggerButton: headerIconButtonProps,
    drawer: {
        size: 400,
        closeButtonProps: {
            variant: "primary",
            css: css`
                width: ${pxToRem(40)};
                height: ${pxToRem(40)};
                padding: 0;
                color: ${getColor("common.background")};
                background-color: ${getColor("primary")};
                border: none;

                [class*="ButtonIcon"] {
                    color: ${getColor("common.background")};
                }
            `,
        },
        cssOverrides: {
            scrim: css`
                border-top: 10px solid ${getColor("common.borderColored")};
            `,
            drawerContainer: css`
                max-width: 320px;
            `,
            drawerContent: css`
                position: relative;
                width: 100%;
                overflow: hidden;
                margin-top: -2px;

                > * {
                    height: 100%;
                    background-color: ${getColor("common.background")};
                }
            `,
            drawerBody: css`
                display: flex;
                flex-direction: row-reverse;
                overflow: hidden;
                background-color: transparent;
                box-shadow: none;
            `,
            drawerTitle: css`
                align-items: baseline;
                min-height: 0;
                padding: 0;
                margin-left: auto;
                background-color: transparent;

                > button:focus {
                    outline: none;
                    background-color: ${getColor("secondary")};
                }
            `,
            titleButton: css`
                display: flex;
                justify-content: center;
                align-items: center;
                width: 40px;
                height: 40px;
                border-radius: 0;
                border: none;
                background: ${getColor("primary")};
                outline: none;
            `,
        },
    },
    drawerSectionWrapper: {
        css: css`
            &:first-child {
                margin-top: 0;
                padding-bottom: 10px;
                background: ${getColor("common.background")};
            }
            &:last-child {
                height: 100vh;
            }
            margin-top: 20px;
        `,
    },
    panelMenu: {
        cssOverrides: {
            wrapper: css`
                > button {
                    width: calc(100% - 2px);
                }
            `,
        },
    },
    panelSectionWrapper: {
        css: css`
            height: 22px;
            display: flex;
            align-items: center;
        `,
    },
    menuRowIcon: {
        size: 22,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    userRowTypography: {
        transform: "capitalize",
        color: "primary",
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.medium};
        `,
    },
    punchOutUserRowText: {
        transform: "capitalize",
        color: "primary",
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.medium};
        `,
    },
    mainNavigationRow: {
        color: "common.background",
    },
    mainNavigationRowIcon: {
        src: Person,
        color: "primary",
        size: 22,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    punchOutNavigationRowIcon: {
        src: Person,
        color: "primary",
        size: 22,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    mainNavigationRowTypography: {
        transform: "capitalize",
        color: "primary",
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.medium};
        `,
    },
    logoLinks: {
        color: "common.background",
        typographyProps: {
            ellipsis: true,
            transform: "capitalize",
        },
        css: css`
            margin: 2px;
        `,
    },
    currencySymbol: {
        size: 22,
        css: css`
            margin-top: -4px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    changeCustomerRow: {
        css: css`
            &:focus {
                outline: none;
            }
        `,
    },
    changeCustomerRowContainer: { gap: 15 },
    fulfillmentMethodGridItem: { width: 12 },
    addressesGridItem: { width: 12 },
    pickUpAddressGridItem: { width: 12 },
    applyButtonGridItem: { width: 12 },
    signOutRowText: {
        transform: "uppercase",
    },
    menuIcon: {
        color: "primary",
        size: 28,
        css: css`
            ${transitionHoverStyles()}

            &:hover {
                color: ${getColor("secondary")};
            }
        `,
    },
    languageMenu: {
        typographyProps: {
            color: "primary",
        },
        css: css`
            * {
                color: ${getColor("primary")};
            }
        `,
    },
    // Sas --->
    buttonsWrapper: {
        css: css`
            padding: ${pxToRem(20)};
            display: flex;
            justify-content: center;
            flex-direction: column;
        `,
    },
    buttons: {
        css: css`
            width: 100%;
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
            ${contentSpacingStyles(pxToRem(14), 0, 0)}
        `,
    },
    // <--- Sas
};

const styles = navigationDrawerStyles;

const NavigationDrawer = ({
    links,
    showQuickOrder,
    quickOrderLink,
    displayVmiNavigation,
    vmiPageLinks,
    displayModeSwitch,
    currentMode,
    isCompactHeaderFlyout,
    showFlyoutPricingToggle,
    showFlyoutInventoryToggle,
    currencies,
    currentCurrencyId,
    currentCurrencySymbol,
    languages,
    currentLanguage,
    currentLocation,
    userName,
    isGuest,
    myAccountPageLink,
    signInUrl,
    vmiDashboardPageUrl,
    homePageUrl,
    headerLinkListLinkFields,
    showCustomerMenuItem,
    fulfillmentLabel,
    navDrawerIsOpen,
    flyoutDrawerIsOpen,
    isPunchOutSession,
    cart,
    history,
    theme,
    displayPricingAndInventoryToggles,
    setCurrency,
    setLanguage,
    signOut,
    cancelPunchOut,
    setInitialValues,
    setNavDrawerIsOpen,
    setFlyoutDrawerIsOpen,
    removeCart,
    setSignInOverlayIsOpen,
    visibilityState,
    // Store Custom Code
    fulfillmentMethod,
    showAddressesSelector,
    userDisplayName,
    uniqueId,
}: Props) => {
    const showIcon = visibilityState === "both" || visibilityState === "icon";
    const showLabel = visibilityState === "both" || visibilityState === "label";
    /* Store Custom Code */
    if (useIsDuplicate("NavigationDrawer", uniqueId)) {
        return null;
    }
    /* Store Custom Code */

    // Sas --->
    const [buttonsArray, setButtonsArray] = React.useState<MappedLink[]>();
    const [linksArray, setlinksArray] = React.useState<MappedLink[]>();

    React.useEffect(() => {
        const _buttonsArray: MappedLink[] = [];
        const _linksArray: MappedLink[] = [...links];

        for (let i = 0; i < links.length; i++) {
            const currentLink = links[i];

            if (currentLink.buttonVariant !== "none") {
                _buttonsArray.push(currentLink);
                _linksArray.splice(i, 1);
            }
        }

        setButtonsArray(_buttonsArray);
        setlinksArray(_linksArray);
    }, [links]);

    const onButtonClick = (destination: string) => {
        window.open(destination);
    };
    // <--- Sas

    const headerLinkListLinks = useGetLinks(headerLinkListLinkFields, o => o.fields.destination);
    const openDrawer = () => {
        isCompactHeaderFlyout ? setFlyoutDrawerIsOpen({ isOpen: true }) : setNavDrawerIsOpen({ navDrawerIsOpen: true });
        setInitialValues({});
    };

    const closeDrawer = () => {
        if (isCompactHeaderFlyout) {
            setFlyoutDrawerIsOpen({ isOpen: false });
            setTimeout(() => setFlyoutDrawerIsOpen({ isOpen: undefined }), 300);
            return;
        }

        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        setTimeout(() => setNavDrawerIsOpen({ navDrawerIsOpen: undefined }), 300);
    };

    const signInPanelClickHandler = (event: React.MouseEvent) => {
        if (theme.signIn?.useOverlay) {
            event.preventDefault();
            setSignInOverlayIsOpen({ isOpen: true });
        }

        closeDrawer();
    };

    const signInPanelKeyPressHandler = (event: React.KeyboardEvent) => {
        if (event.key === " " && history && signInUrl?.url) {
            event.preventDefault();

            if (theme.signIn?.useOverlay) {
                setSignInOverlayIsOpen({ isOpen: true });
            } else {
                history.push(signInUrl.url);
            }

            closeDrawer();
        }
    };

    const onSignOutHandler = () => {
        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        isPunchOutSession ? cancelPunchOut() : signOut();
    };

    const navigationModeChangeHandler = (navigationMode: "Storefront" | "Vmi") => {
        setCookie(NavigationModeCookieName, navigationMode);
        if (navigationMode === "Vmi") {
            vmiDashboardPageUrl && history.push(vmiDashboardPageUrl);
        } else if (cart?.status === "AlternateCart") {
            removeCart({
                cartId: API_URL_CURRENT_FRAGMENT,
                isAlternateCart: true,
                onSuccess: () => {
                    homePageUrl && history.push(homePageUrl);
                },
            });
        } else {
            homePageUrl && history.push(homePageUrl);
        }
    };

    const currentPageUrl = currentLocation.pathname;
    const isOpen = isCompactHeaderFlyout ? flyoutDrawerIsOpen : navDrawerIsOpen;

    /* Store Custom Code */
    const accountMenuItems: MappedLink[] = [
        ...((myAccountPageLink?.children || []) as any),
        {
            title: translate("Sign Out"),
            clickableProps: {
                onClick: onSignOutHandler,
            },
        },
    ];
    /* Store Custom Code */

    // Foundation --->
    const displayName = useDisplayName();
    // <--- Foundation

    return (
        <>
            <Button
                className="menu-trigger-button"
                onClick={openDrawer}
                {...styles.menuTriggerButton}
                data-test-selector="expandMobileMenu"
            >
                <ButtonIcon className="menu-trigger-button-icon" src={Menu} />
                <VisuallyHidden>{translate("menu")}</VisuallyHidden>
            </Button>
            <Drawer
                className="drawer"
                draggable
                position="left"
                {...styles.drawer}
                isOpen={isOpen}
                handleClose={closeDrawer}
                contentLabel="menu drawer"
            >
                <StyledSection
                    className="drawer-section-wrapper"
                    {...styles.drawerSectionWrapper}
                    // Store Custom Code
                    aria-label={translate("Primary Menu")}
                >
                    {/* Sas Removed Code */}
                    {/* covers MainNavigation functionality */}
                    {
                        /* Sas */ linksArray?.map((link, index) => {
                            if (link.children && link.children.length > 0) {
                                return (
                                    <PanelMenu
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={`${index}${link.title}`}
                                        currentUrl={currentPageUrl}
                                        closeOverlay={closeDrawer}
                                        panelTrigger={
                                            <PanelRow hasChildren {...styles.mainNavigationRow}>
                                                <Typography {...styles.mainNavigationRowTypography}>
                                                    {link.title}
                                                </Typography>
                                            </PanelRow>
                                        }
                                        menuItems={link.children}
                                        maxDepth={link.maxDepth || 3}
                                        layer={0}
                                        {...styles.panelMenu}
                                        parent={link} // Store Custom Code
                                    />
                                );
                            }
                            return (
                                <PanelRow
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={`${index}${link.title}`}
                                    href={link.url}
                                    target={link.openInNewWindow ? "_blank" : ""}
                                    {...styles.mainNavigationRow}
                                >
                                    <Typography {...styles.mainNavigationRowTypography}>{link.title}</Typography>
                                </PanelRow>
                            );
                        })
                    }
                    {/* Store Custom Code */}
                    {showQuickOrder && quickOrderLink && (
                        <PanelRow
                            isCurrent={currentPageUrl === quickOrderLink.url}
                            onClick={closeDrawer}
                            href={quickOrderLink.url}
                            {...styles.mainNavigationRow}
                        >
                            <Typography {...styles.mainNavigationRowTypography}>{quickOrderLink.title}</Typography>
                        </PanelRow>
                    )}
                    {headerLinkListLinks.length > 0 ? (
                        headerLinkListLinks.map((link, index) => (
                            <PanelRow
                                // eslint-disable-next-line react/no-array-index-key
                                key={`${index}${link.title}`}
                                {...styles.mainNavigationRow}
                                isCurrent={currentPageUrl === link.url}
                                onClick={closeDrawer}
                                href={link.url}
                                target={headerLinkListLinkFields[index].openInNewWindow ? "_blank" : ""}
                            >
                                <Typography {...styles.mainNavigationRowTypography}>
                                    {
                                        headerLinkListLinkFields[index].fields.overriddenTitle ||
                                            link.title /* Store Custom Code */
                                    }
                                </Typography>
                            </PanelRow>
                        ))
                    ) : (
                        <></>
                    )}
                    {languages?.length && languages?.length > 1 ? (
                        <PanelRow {...styles.mainNavigationRow}>
                            <LanguageMenu displayName {...styles.languageMenu} />
                        </PanelRow>
                    ) : null}
                    {/* Store Custom Code */}
                    {/* Starter Removed Code - QuickOrder - Native HeaderLinkList - Native Language Selector */}
                    {userName && !isGuest && (
                        <PanelRow className="sign-out-row" onClick={onSignOutHandler} {...styles.signOutRow}>
                            <Typography {...styles.mainNavigationRowTypography /* Store Custom Code */}>
                                {isPunchOutSession ? translate("Cancel PunchOut") : translate("Sign Out")}
                            </Typography>
                        </PanelRow>
                    )}
                    {/* Sas ---> */}
                    <PanelRow {...styles.buttonsWrapper}>
                        {buttonsArray?.map((button, index) => (
                            <Button
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                variant={button.buttonVariant as ButtonVariants}
                                onClick={() => onButtonClick(button.url)}
                                {...styles.buttons}
                            >
                                {button.title}
                            </Button>
                        ))}
                    </PanelRow>
                    {/* <--- Sas */}
                </StyledSection>
            </Drawer>
        </>
    );
};

const LogoImage = styled.img`
    margin-right: 10px;
    height: 22px;
`;

interface SelectorMenuProps {
    options?: MappedLink[];
    closeModal?: () => void;
    currentOption?: string;
    currentOptionIcon?: React.ReactNode;
    dataTestSelector?: string;
}

const SelectorMenu: React.FC<SelectorMenuProps> = ({
    options,
    closeModal,
    currentOption,
    currentOptionIcon,
    dataTestSelector,
}) => {
    if (!options || options.length <= 1) {
        return null;
    }

    const trigger = (
        <PanelRow hasChildren className="logo-links-row" {...styles.logoLinks}>
            <StyledSpan className="panel-section-wrapper" {...styles.panelSectionWrapper}>
                {currentOptionIcon}
                <Typography
                    className="logo-link-title"
                    data-test-selector={`${dataTestSelector}_currentOption`}
                    {...styles.logoLinks?.typographyProps}
                >
                    {currentOption}
                </Typography>
            </StyledSpan>
        </PanelRow>
    );

    return (
        <PanelMenu
            className="panel-menu"
            currentUrl={currentOption}
            data-test-selector={dataTestSelector}
            closeOverlay={closeModal}
            panelTrigger={trigger}
            menuItems={options}
            maxDepth={1}
            layer={0}
            {...styles.panelMenu}
        />
    );
};

function findVisibilityState(data: any): string | undefined {
    for (const key in data) {
        if (data[key].type === "Common/HeaderSignIn") {
            return data[key].generalFields.visibilityState;
        }
    }
    return undefined;
}

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(NavigationDrawer)));
